var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-booking",
    transform: "translate(-40 -200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_35",
    "data-name": "Ret\\xE2ngulo 35",
    transform: "translate(40 200)",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2914",
    "data-name": "Caminho 2914",
    d: "M5.75,2A1.75,1.75,0,0,0,4,3.75v14A1.75,1.75,0,0,0,5.75,19.5h10.5A1.75,1.75,0,0,0,18,17.75V7.25L12.75,2m-.875,1.313,4.813,4.813H11.875M9.294,10.068l2.476,2.476,1.855-1.855v6.186H7.439L9.294,15.02,6.817,12.544",
    transform: "translate(39 199.25)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBooking);
export default __webpack_public_path__ + "static/media/icon-booking.568a65010010df519dc102bd82379ac0.svg";
export { ForwardRef as ReactComponent };